import { AppBar, makeStyles, Tab, Tabs, Theme } from '@material-ui/core';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import TabPanel from '../../TabPanel';
import MelhorEnvio from './MelhorEnvio';
import IFood from './iFood';
import { IfoodImport } from './IfoodImport';
import PagBank from './PagBank';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

const Integrations: React.FC = () => {
  const classes_root = useStyles();

  const location = useLocation();
  const [tab, setTab] = useState(() =>
    new URLSearchParams(location.search).has('pagbank') ? 3 : 0,
  );

  const a11yProps = (index: number): a11yPropsReturnType => {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  };

  return (
    <div className={classes_root.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="config_tabs"
        >
          <Tab label="Melhor Envio" {...a11yProps(0)} />
          <Tab label="iFood" {...a11yProps(1)} />
          <Tab label="iFood Import" {...a11yProps(2)} />
          <Tab label="PagBank" {...a11yProps(3)} />
        </Tabs>
      </AppBar>

      <TabPanel
        value={tab}
        index={0}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <MelhorEnvio />
      </TabPanel>
      <TabPanel
        value={tab}
        index={1}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <IFood />
      </TabPanel>
      <TabPanel
        value={tab}
        index={2}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <IfoodImport />
      </TabPanel>
      <TabPanel
        value={tab}
        index={3}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <PagBank />
      </TabPanel>
    </div>
  );
};

export default Integrations;
